define((require) => {
    "use strict";

    const Marionette         = require("marionette");
    const template           = require("shared/ui/experience/widgets/compositeWidget/CompositeWidgetLayout.tpl");

    return Marionette.Layout.extend({

        template,

        regions: {
            "groupOverlay": ".group-overlay",
            "group":   ".group"
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/compositeWidget/CompositeWidgetLayout.js